import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { router } from './config/router';

import './styles/global.css';
import ReactVLibras from 'react-vlibras-plugin';
import { Toaster } from 'react-hot-toast';

const AppWrapper = () => {
  return (
    <>
      <RouterProvider router={router} />
      <ReactVLibras position="right" avatar="guga" opacity={0.8} />
    </>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <AppWrapper />
    <Toaster
      position="top-center"
      reverseOrder={false}
      toastOptions={{
        duration: 4000,
        style: {
          background: '#1E3A8A',
          color: '#fff',
          fontSize: '14px',
          borderRadius: '8px',
          padding: '16px',
        },
        success: {
          iconTheme: {
            primary: '#22c55e', // verde
            secondary: '#fff',
          },
        },
        error: {
          iconTheme: {
            primary: '#ef4444', // vermelho
            secondary: '#fff',
          },
        },
      }}
    />
  </React.StrictMode>,
);
